<template>
<div>
  <Header/>
  <b-card class="bCardGlobalXL">
    <loading :active.sync="loaderGuardar" :can-cancel="false" :is-full-page="true"></loading>
    <div class="text-left">
      <span style="font-size: 13px; color: #0069A9;font-weight: 600"> Nueva orden de trabajo </span>
    </div>

    <b-row>
      <b-col class="text-left mt-4" >
        <div style="font-size: 11px; display: contents">
          <strong>Paciente:</strong> <span>{{ this.$route.params.nombrePaciente }}</span>
          <br/>
          <span>Sexo:</span>
          <span>
                  {{
                    this.$route.params.sexo == 1
                        ? "Masculino"
                        : this.$route.params.sexo == 2
                            ? "Femenino"
                            : "No responder"
                  }}
          </span>
          <br/>
          <span>Edad:</span> <span>{{ this.$route.params.edad }} años</span>
          <br/>
          <span>Fecha de solicitud: {{ this.$moment(new Date()).format("DD/MMMM/YYYY")}}</span>
        </div>
      </b-col>
      <b-col class="text-right">
        <img style="max-width: 142px;" alt="Vue logo" src="../../../assets/dentalia.jpg" class="dentaliaLogo"/>
      </b-col>
    </b-row>
    <br/>
        <div v-if="this.$route.params.tipoOdt != 1">
          <span style="color: #1596AA; font-weight: 500"> ODT
                  {{
                    this.$route.params.tipoOdt == 2
                        ? "Ajuste"
                        : this.$route.params.tipoOdt == 3
                            ? "Devolución"
                            : this.$route.params.tipoOdt == 4
                                ? "Repetición"
                            : " "
                  }}
          </span>
        </div>

    <div v-for="(ap, index) in listaCategorias" :key="index" class="mt-2 d-flex justify-content-center" >

      <b-card no-body class="mb-2" :class="{
        'cardOdtNoSel': cardSeleccionado !== index,
        'cardOdtSel': cardSeleccionado === index,
        'cardOdtComplete' : cardsCompletadas.includes(index)
      }  " style="width: 98%">

        <b-col
            :class="{
              'tituloCard seleccionado': cardSeleccionado === index,
              'tituloCard completado': cardsCompletadas.includes(index),
              'tituloCard': cardSeleccionado !== index
            }"
            class="text-center"
            style="margin: 20px; position: relative">
            <span v-b-toggle="'collapseODT-'+index">
              {{ap.idCategoria}}. {{ ap.name }}
              <span v-if="cardsCompletadas.includes(index)"><i class="fa fa-check" style="color:#28a745; font-size: 16px "></i></span>
            </span>
          <em v-if="cardsCompletadas.includes(index)" class= "edit_outline_svg" style="width: 21px; cursor: pointer; position: absolute; right: 35px;"
              v-b-tooltip.hover.topleft.v-light
              title="Editar"
              @click="editarPaso(index)"
          ></em>
        </b-col>


        <b-collapse :id="'collapseODT-'+index" v-model="ap.cardAbierto">
          <b-card-body v-if="ap.idCategoria === 1" class="scrollCard">
            <b-row>
              <b-col align="left">
                <em class="info_padecimiento"
                    v-b-tooltip.hover.topright.v-light
                    title="Sólo se muestran tratamientos multisesión pagados"></em>
              </b-col>
            </b-row>
            <InformacionTratamiento ref="componenteTratamientos"
                                    v-if="idOdt == 1 || idOdt == 0"
                                    :odtMadre="odtMadre"
                                    :ap="ap.idCategoria"
                                    :index="index"
                                    :listaTratamientos="listaTratamientos"
                                    :deshabilitado="cardsCompletadas.includes(index)"
                                    @siguiente="siguiente"/>
            <InformacionTratamiento ref="componenteTratamientos"
                                    v-else-if=" datosCargados"
                                    :odtMadre="odtMadre"
                                    :ap="ap.idCategoria"
                                    :index="index"
                                    :listaTratamientos="listaTratamientos"
                                    :deshabilitado="cardsCompletadas.includes(index)"
                                    @siguiente="siguiente"/>
          </b-card-body>
          <b-card-body v-if="ap.idCategoria === 2" class="scrollCard">
            <InformacionGeneralOdt ref="componenteInfoGeneral"
                                   v-if="odt != null && (idOdt == 1 || idOdt == 0) "
                                   :odtMadre="odtMadre"
                                   :ap="ap.idCategoria"
                                   :listaClinicas.sync="listaClinicas"
                                   :deshabilitado="cardsCompletadas.includes(index)"
                                   :listaDoctores.sync="listaDoctores"
                                   :datos="odt"
                                   @siguiente="siguiente"/>
            <InformacionGeneralOdt ref="componenteInfoGeneral"
                                   v-else-if="odt != null && datosCargados"
                                   :odtMadre="odtMadre"
                                   :ap="ap.idCategoria"
                                   :listaClinicas.sync="listaClinicas"
                                   :deshabilitado="cardsCompletadas.includes(index)"
                                   :listaDoctores.sync="listaDoctores"
                                   :datos="odt"
                                   @siguiente="siguiente"/>
          </b-card-body>
          <b-card-body v-if="ap.idCategoria === 3" class="scrollCard">
          <!--      Proveedor          -->
            <Proveedor ref="componenteProveedor"
                       v-if="idOdt == 1 || idOdt == 0"
                      :odtMadre="odtMadre"
                      :datos="odt"
                      :listLaboratorios="listLaboratorios"
                      :productosLaboratorios="productosLaboratorios"
                      :deshabilitado="cardsCompletadas.includes(index)"
                      @siguiente="siguiente"
            />
            <Proveedor ref="componenteProveedor"
                       v-else-if="datosCargados"
                      :odtMadre="odtMadre"
                      :datos="odt"
                      :listLaboratorios="listLaboratorios"
                      :productosLaboratorios="productosLaboratorios"
                      :deshabilitado="cardsCompletadas.includes(index)"
                      @siguiente="siguiente"
            />
          </b-card-body>
          <b-card-body v-if="ap.idCategoria === 4" class="scrollCard">
          <!--    Detalles del trabajo   Flujo digital    -->
            <FlujoDigital ref="componenteDetalle" v-if="odt !== null && odt.infoTratamiento !== null
                          && odt.proveedor !== null && odt.infoGeneral !== null
                          && odt.infoGeneral.flujo === 2 && odt.infoGeneral.escaner !== null"
                          :escaner="odt.infoGeneral.escaner"
                          :ruta="rutaBaseArchivos"
                          :idPaciente="Number(idPaciente)"
                          :loader="loaderGuardar"
                          @finalizar="finalizarOdt"/>

            <!--    Detalles del trabajo Flujo Físico      -->
            <ProtesisFijaRemovible ref="componenteDetalle"
                v-if="odt !== null && odt.infoGeneral !== null && odt.infoGeneral.flujo === 1 && (odt.infoTratamiento.idTipoFlujoFisico === 1 || odt.infoTratamiento.idTipoFlujoFisico === 2)"
                :dientesSeleccionados="dientesSeleccionados"
                @finalizarOdt="finalizarOdt"
                :listaElementosProps="listaElementos"
                :odtProp="odt"
                :listaColorimetrosProps="listaColorimetros"
                :tipoFlujoFisico="odt.infoTratamiento.idTipoFlujoFisico"
                :listaMarcasProps="listaMarcas"
                :listaDiametroProps="listaDiametros"
                :listaConexionProps="listaConexion"
                :ruta="rutaBaseArchivos"
                :idPaciente="Number(idPaciente)"
                :aplicaRestauracionesProp="aplicaRestauraciones"
                :loader="loaderGuardar"
            />

            <OrtodonciaOrtopedia ref="componenteDetalle"
                v-if="odt !== null && odt.infoGeneral !== null && odt.infoGeneral.flujo === 1 && odt.infoTratamiento.idTipoFlujoFisico === 3"
                :datos="odt"
                :listaElementosProps="listaElementos"
                :listaAparatosProps="listaAparatos"
                :listaAccesoriosProps="listaAccesorios"
                :listaColoresProps="listaColores"
                :ruta="rutaBaseArchivos"
                :idPaciente="Number(idPaciente)"
                :tipoFlujoFisico="odt.infoTratamiento.idTipoFlujoFisico"
                @finalizarOdt="finalizarOdt"
                :loader="loaderGuardar"/>

            <Guarda ref="componenteDetalle"
                v-if="odt !== null && odt.infoGeneral !== null && odt.infoGeneral.flujo === 1 && odt.infoTratamiento.idTipoFlujoFisico === 4"
            :listaTiposAcrilico="listaTiposAcrilico" :listaTiposCalibre="listaTiposCalibre" :listaTiposRecorte="listaTiposRecorte" :tipoFlujoFisico="odt.infoTratamiento.idTipoFlujoFisico" @finalizar="finalizarOdt" :loader="loaderGuardar"/>
          </b-card-body>
        </b-collapse>
      </b-card>


    </div>

  </b-card>
</div>

</template>
<script>
import Header from "@/components/Header.vue";
import Proveedor from "@/views/LaboratorioV2/SolicitudODT/Proveedor.vue";
import ProtesisFijaRemovible from "@/views/LaboratorioV2/SolicitudODT/ProtesisFijaRemovible.vue";
import InformacionTratamiento from "./InformacionTratamiento.vue";
import InformacionGeneralOdt from "./InformacionGeneralOdt.vue";
import OrtodonciaOrtopedia from "./OrtodonciaOrtopedia.vue";
import FlujoDigital from "@/views/LaboratorioV2/DetalleTrabajo/FlujoDigital.vue";
import Guarda from "../DetalleTrabajo/Guarda.vue";
import {DeleteObjectsCommand, S3Client} from "@aws-sdk/client-s3";
import moment from "moment";
import {AwsService} from "@/apiServices/aws/AwsService";

export default {
  name: "OrdenTrabajoPaciente",
  components: {
    FlujoDigital, ProtesisFijaRemovible, Proveedor, Header, InformacionTratamiento, InformacionGeneralOdt, OrtodonciaOrtopedia, Guarda},
  data: () => ({
    cardSeleccionado: 0,
    cardsCompletadas: [],
    listaCategorias: [
      { name: "Información del tratamiento", nombreBase: "Información del tratamiento", idCategoria: 1, cardAbierto: true },
      { name: "Información general", nombreBase: "Información general", idCategoria: 2, cardAbierto: false },
      { name: "Proveedor", nombreBase: "Proveedor", idCategoria: 3, cardAbierto: false },
      { name: "Detalles del trabajo", nombreBase: "Detalles del trabajo", idCategoria: 4, cardAbierto: false },
    ],
    listLaboratorios: [],
    productosLaboratorios: [],

    odt: {
      infoTratamiento: null,
      infoGeneral: null,
      proveedor: null,
      flujoDigital: null,
      observaciones: null,
      listaArchivosGuardar: [],
    },
    listaTratamientos: [],
    listaClinicas: [],
    listaDoctores: [],
    listaTiposAcrilico: [],
    listaTiposCalibre: [],
    listaTiposRecorte: [],

    blnSeccionArchivos: false,
    listaElementos: [],
    listaAparatos: [],
    listaAccesorios: [],
    listaColores: [],
    listaColorimetros: [],
    listaDiametros: [],
    listaConexion: [],
    listaMarcas: [],

    dientesSeleccionados: [],

    awsServicio: new AwsService(),
    token: null,
    rutaBaseArchivos: null,
    idPaciente: null,
    aplicaRestauraciones: false,

    infoGeneralRef: null,
    loaderGuardar: false,

    idOdt: null,
    odtMadre: {
      infoTratamiento: null,
      infoGeneral: null,
      proveedor: null,
    },
    datosCargados: false,
  }),
  async created() {
    await this.validarTokenAWS();
    this.obtenerCatalogos();
    this.obtenerRutaODT();
    this.idPaciente = this.$route.params.idPaciente;
    this.idOdt = this.$route.params.idOdt;
    this.tipoOdt = this.$route.params.tipoOdt;
    if(this.idOdt != 1 && this.idOdt != 0){
      this.obtenerDatosOdtMadre();
    }
  },
  methods: {
    obtenerCatalogos(){

      this.obtenerTratamientos();
      this.obtenerClinicas();
      this.obtenerEmpleados();
      this.obtenerElementos();
      this.obtenerAparatos();
      this.obtenerAccesorios();
      this.obtenerColores();
      this.obtenerTiposAcrilico();
      this.obtenerTiposRecorte();
      this.obtenerTiposCalibre();


    },
    obtenerProovedores(clinicaSeleccionada, flujoDigital, trat ){
      this.listLaboratorios = [];
      const envio = {
        idClinica: clinicaSeleccionada,
        idTratamiento: trat.idTratamiento,
        idTipoFlujoFisico: trat.idTipoFlujoFisico,
      }


      this.$http.post(this.$api + "labs/productos/clinica", envio).then(resp => {
        if (resp.data.data) {
              this.productosLaboratorios = resp.data.data;
               this.listLaboratorios = resp.data.data.filter((value, index, self) => {
                  return self.findIndex(item => item.idLaboratorio === value.idLaboratorio) === index;
                });

               if (flujoDigital){
                 this.listLaboratorios = this.listLaboratorios.filter(l => l.flujoDigital === flujoDigital)
               }


        }
      })
    },
    abrirCard(index) {
      if (this.cardSeleccionado === index && this.listaCategorias[index].cardAbierto) return;
      this.listaCategorias.forEach(item => {
        item.cardAbierto = false;
      });
      this.cardSeleccionado = index;
      this.listaCategorias[index].cardAbierto = true;
    },

    siguiente(datos, index){
      if (index > 0){
        if (!this.cardsCompletadas.includes(index - 1)){
          this.$swal({
            title: "Finalice el paso anterior",
            icon: "error",
          });
          return;
        }
      }

      switch (index){
        case 0:
          this.odt.infoTratamiento = JSON.parse(JSON.stringify( datos) );
          this.dientesSeleccionados = this.odt.infoTratamiento.dientes;
          this.aplicaRestauraciones = this.odt.infoTratamiento.aplicaRestauraciones
          this.listaCategorias[index].name = `${this.listaCategorias[index].nombreBase} (${this.odt.infoTratamiento.nombreTratamiento})`;
          break
        case 1:
          this.odt.infoGeneral = JSON.parse(JSON.stringify( datos) );
          if (this.odt.infoGeneral !== null && this.odt.infoGeneral.clinicaSeleccionada !== null){
            this.obtenerProovedores(this.odt.infoGeneral.clinicaSeleccionada, this.odt.infoGeneral.flujo === 2, this.odt.infoTratamiento );
          }

          if (this.odt.infoGeneral.flujo === 1 && (this.odt.infoTratamiento.idTipoFlujoFisico === 1 || this.odt.infoTratamiento.idTipoFlujoFisico === 2 )){

            /*Si aplica para restauraciones implantosoportadas*/
            this.obtenerDiametros();
            this.obtenerConexion();
            this.obtenerMarca();
          }
          break
        case 2: {
          const nombreLab = this.listLaboratorios?.find(
              (l) => l.idLaboratorio === datos.idLaboratorio
          )?.nombreLaboratorio || "";

          this.listaCategorias[index].name = `${this.listaCategorias[index].nombreBase} (${nombreLab})`;

          this.odt.proveedor = JSON.parse(JSON.stringify(datos));
          this.obtenerColorimetros(this.odt.proveedor.idLaboratorio);
          this.asignarNombreDetalleTrabajo();
          break;
        }
      }

      if (!this.cardsCompletadas.includes(index)) {
        this.cardsCompletadas.push(index);
      }
      const nextIndex = index + 1;
      if (nextIndex < this.listaCategorias.length) {
        this.abrirCard(nextIndex);
      }
    },

    finalizarOdt(datos){
      this.loaderGuardar = true;
      if(this.odt.infoGeneral.flujo === 2){
        this.odt.flujoDigital = JSON.parse(JSON.stringify( datos) );
      }else{

        switch (this.odt.infoTratamiento.idTipoFlujoFisico) {
          case 1: this.odt.protesis = JSON.parse(JSON.stringify( datos) );
            break;

          case 2: this.odt.protesis = JSON.parse(JSON.stringify( datos) );
                this.odt.observaciones = this.odt.protesis.observaciones
            break;

          case 3: this.odt.ortodonciaOrtopedia = JSON.parse(JSON.stringify( datos) );
            break;

          case 4: this.odt.guarda = JSON.parse(JSON.stringify( datos) );
            break;
        }
      }

      if (this.$route.params.idOdt !== 0){
        this.odt.idOdtMadre = this.$route.params.idOdt;
        this.odt.idTipoOdt = this.$route.params.tipoOdt;
        this.odt.idOrigenOdt = this.$route.params.origenOdt;
        this.odt.idSolicitudPadre = this.$route.params.idSolicitud;
      }

      if(Number(this.$route.params.origenOdt) === 2){
        this.odt.idTipoOdt = this.$route.params.tipoOdt;
        this.odt.idOrigenOdt = this.$route.params.origenOdt;
      }

      this.odt.observaciones = datos?.observaciones ? datos.observaciones : null;
      this.odt.listaArchivosGuardar = datos?.listaArchivosGuardar ? datos.listaArchivosGuardar : [];

      if (this.odt.observaciones == null) {
        this.$swal({
          title: 'Falta agregar observaciones',
          icon: 'warning',
          timer: 2500
        });
        this.loaderGuardar = false;
        return;
      }

      this.$http.post(this.$api + "labs/odt/guardar", this.odt).then(response => {
        if (response.status === 200) {
          if(response.data.data != null){
            this.$swal({
              icon: "success",
              title: "Éxito",
              text: "La ODT se ha registrado correctamente",
            });
            window.history.back();
          }else{
            if (this.odt.listaArchivosGuardar.length > 0) {
              this.eliminarArchivosEx(this.odt.listaArchivosGuardar);
            }
          }
        }
      }).catch(error => {
        console.log(error);
        this.loaderGuardar = false;
        this.eliminarArchivosEx(datos.listaArchivosGuardar);
      }).finally(() => {
        this.loaderGuardar = false;
      })
    },

    obtenerTratamientos(){
      let params = {
        idPaciente: this.$route.params.idPaciente,
        idOdtLaboratorioMadre: this.$route.params.idOdt,
        tipoOdt: this.$route.params.tipoOdt,
      }
      this.$http.post(this.$api + "catalogos/obtener/tratamientosProgramados/odt", params).then(response => {
        if (response.data.data) {
          this.listaTratamientos = response.data.data;
        }
      })
    },
    obtenerClinicas(){
      this.$http.post(this.$api + "catalogos/listaClinicasOdt", this.$localStorageService.getIdEmpleado()).then(response => {
        if (response.data.data) {
          this.listaClinicas = response.data.data;
        }
      })
    },
    obtenerEmpleados(){
      this.$http.get(this.$api + "diagnostico/hoja/listaDoctores/odt").then(response => {
        if (response.data.data) {
          this.listaDoctores = response.data.data;
        }
      })
    },

    obtenerTiposAcrilico() {
      this.$http.get(this.$api + "catalogo/guarda/tipo/acrilico").then(response => {
        this.listaTiposAcrilico = response.data.data;
      }).catch(error => {
        this.$swal({
          icon: "error",
          title: "Error",
          html: error.message,
        });
      })

    },

    obtenerTiposRecorte() {
      this.$http.get(this.$api + "catalogo/guarda/tipo/recorte").then(response => {
        this.listaTiposRecorte = response.data.data;
      }).catch(error => {
        this.$swal({
          icon: "error",
          title: "Error",
          html: error.message,
        });
      })

    },

    obtenerTiposCalibre() {
      this.$http.get(this.$api + "catalogo/guarda/tipo/calibre").then(response => {
        this.listaTiposCalibre = response.data.data;
      }).catch(error => {
        this.$swal({
          icon: "error",
          title: "Error",
          html: error.message,
        });
      })
    },
    obtenerColorimetros(idLaboratorio){
      this.listaColorimetros = [];
      const params = {
        idLaboratorio: idLaboratorio,
      }
      this.$http.post(this.$api + "labs/colorimetros", params).then(response => {
        if (response.data.data) {
          const colorimetros = response.data.data;
          colorimetros.forEach(element => {
            element.flujo.forEach(f => {
              if (f.idTipoFlujoFisico === this.odt.infoTratamiento.idTipoFlujoFisico){
                this.listaColorimetros.push(element);
              }
            })
          })
          //this.listaColorimetros = colorimetros.filter(c => c.idTipoFlujoFisico === this.odt.infoTratamiento.idTipoFlujoFisico)

        }
      })
    },

    editarPaso(index){
      this.$swal({
        icon: "warning",
        title: "Editar etapa anterior",
        html:" Esta acción borrará los datos actuales y te llevará a una etapa anterior, ¿Quieres continuar?" ,
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: "Sí, continuar",
        cancelButtonText: "No, cancelar",
        confirmButtonColor: "#1b81af",
        cancelButtonColor: "#fff",
        customClass: {
          confirmButton: "rounded-pill text-small",
          cancelButton: " rounded-pill text-small border border-secondary text-secondary",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.abrirCard(index);
          this.cardsCompletadas = this.cardsCompletadas.filter((i) => i < index);

          for (let i = index; i < this.listaCategorias.length; i++) {
            this.listaCategorias[i].name = this.listaCategorias[i].nombreBase;
          }

          if (index === 0) {
            this.$refs.componenteTratamientos[0].reset();
            this.odt.infoTratamiento = null;
          }
          if (index <= 1) {
            this.$refs.componenteInfoGeneral[0].reset();
            this.odt.infoGeneral = null;
          }
          if (index <= 2) {
            this.$refs.componenteProveedor[0].reset();
            this.odt.proveedor = null;
          }

          if (index <= 3) {
            this.$refs.componenteDetalle[0].reset();
            this.odt.detalleTrabajo = null;
          }


        }
      });
    },
    obtenerElementos(){
      this.$http.get(this.$api + "labs/elementos").then(response => {
        if (response.data.data) {
          this.listaElementos = response.data.data;
        }
      })
    },

    obtenerAparatos(){
      this.$http.get(this.$api + "labs/aparatos").then(response => {
        if (response.data.data) {
          this.listaAparatos = response.data.data;
        }
      })
    },

    obtenerAccesorios(){
      this.$http.get(this.$api + "labs/accesorios").then(response => {
        if (response.data.data) {
          this.listaAccesorios = response.data.data;
        }
      })
    },

    obtenerColores(){
      this.$http.get(this.$api + "labs/colores").then(response => {
        if (response.data.data) {
          this.listaColores = response.data.data;
        }
      })
    },

    async eliminarArchivosEx(listaArchivos = []) {
      await this.validarTokenAWS();

      if (listaArchivos.length === 0) {
        this.$swal({
          title: 'No hay archivos para eliminar',
          icon: 'warning',
          timer: 2500
        });
        return;
      }

      const client = new S3Client({
        region: this.token.regionBucket,
        credentials: {
          accessKeyId: this.token.accessKeyId,
          secretAccessKey: this.token.secretAccessKey,
          sessionToken: this.token.sessionToken,
        },
      });

      try {
        const objetosAEliminar = listaArchivos
            .filter(archivo => archivo.urlRuta) // aseguramos que exista
            .map(archivo => ({ Key: archivo.urlRuta }));

        if (objetosAEliminar.length === 0) {
          console.warn("No hay rutas válidas para eliminar.");
          return;
        }

        const deleteParams = {
          Bucket: this.token.nombreBucket,
          Delete: {
            Objects: objetosAEliminar,
          },
        };

        const deleteCommand = new DeleteObjectsCommand(deleteParams);
        await client.send(deleteCommand);
        console.log("Archivos eliminados correctamente de S3.");
      } catch (deleteError) {
        console.error("Error al eliminar archivos de S3:", deleteError);
      }
    },



    async validarTokenAWS() {
      if (this.token !== null) {
        if (this.token.expireTo < moment(new Date()).format("YYYY-MM-DD HH:mm:ss")) {
          await this.awsServicio.obtenerTokenAcceso().then((response) => {
            this.token = response.data
            this.$localStorageService.setTokenAWS(this.token)
          })
        }else{
          if(typeof this.token === 'string'){
            this.token = JSON.parse(this.token);
          }
        }
      } else {
        await this.awsServicio.obtenerTokenAcceso().then((response) => {
          this.token = response.data
          this.$localStorageService.setTokenAWS(this.token)
        })
      }
    },

    obtenerDiametros(){
      this.$http.get(this.$api + "labs/diametro").then(response => {
        if (response.data.data) {
          this.listaDiametros = response.data.data;
        }
      })
    },

    obtenerConexion(){
      this.$http.get(this.$api + "labs/conexion").then(response => {
        if (response.data.data) {
          this.listaConexion = response.data.data;
        }
      })
    },
    obtenerMarca(){
      this.$http.get(this.$api + "labs/marca").then(response => {
        if (response.data.data) {
          this.listaMarcas = response.data.data;
        }
      })
    },

    obtenerRutaODT(){
      this.$http.get(this.$api + "rutaExpediente/rutaODT")
          .then((response) => {
            this.rutaBaseArchivos = response.data.data;
          })
          .catch((error) => {
            console.error(error);
          }).finally(() =>{});
    },

    asignarNombreDetalleTrabajo() {
      const lastIndex = this.listaCategorias.length - 1;
      if (this.odt.infoGeneral.flujo === 2) return;
      const nombreBase = this.listaCategorias[lastIndex].nombreBase;
      switch (this.odt.infoTratamiento.idTipoFlujoFisico) {
        case 1: {
          this.listaCategorias[lastIndex].name = `${nombreBase} (Protesis Fija)`;
          break;
        }
        case 2: {
          this.listaCategorias[lastIndex].name = `${nombreBase} (Protesis Removible)`;
          break;
        }
        case 3: {
          this.listaCategorias[lastIndex].name = `${nombreBase} (Ortodoncia y Ortopedia)`;
          break;
        }
        case 4: {
          this.listaCategorias[lastIndex].name = `${nombreBase} (Guarda)`;
          break;
        }
      }
    },

    obtenerDatosOdtMadre(){
      const params = {
        idOdt: this.$route.params.idOdt,
      }
      this.$http.post(this.$api + "labs/odt/obtenerOdtMadre", params).then(response => {
        if (response.data.data) {

          this.odtMadre = response.data.data;
          this.obtenerProovedores(this.odtMadre.infoGeneral.clinicaSeleccionada, this.odtMadre.infoGeneral.flujo === 2, this.odtMadre.infoTratamiento );

          this.cardsCompletadas = [0, 1, 2]

          this.cardsCompletadas.forEach(c => {

            switch (c){
              case 0:
                this.odt.infoTratamiento = JSON.parse(JSON.stringify( this.odtMadre.infoTratamiento ) );
                this.odt.infoTratamiento.idPaciente = this.idPaciente;
                this.dientesSeleccionados = this.odt.infoTratamiento.dientes;
                this.aplicaRestauraciones = this.odt.infoTratamiento.aplicaRestauraciones
                this.listaCategorias[c].name = `${this.listaCategorias[c].nombreBase} (${this.odt.infoTratamiento.nombreTratamiento})`;
                break
              case 1:
                this.odt.infoGeneral = JSON.parse(JSON.stringify( this.odtMadre.infoGeneral) );


                if (this.odt.infoGeneral.flujo === 1 && (this.odt.infoTratamiento.idTipoFlujoFisico === 1 || this.odt.infoTratamiento.idTipoFlujoFisico === 2 )){

                  /*Si aplica para restauraciones implantosoportadas*/
                  this.obtenerDiametros();
                  this.obtenerConexion();
                  this.obtenerMarca();
                }
                break
              case 2: {
                const nombreLab = this.odtMadre.proveedor.nombreLab;

                this.listaCategorias[c].name = `${this.listaCategorias[c].nombreBase} (${nombreLab})`;

                this.odt.proveedor = JSON.parse(JSON.stringify(this.odtMadre.proveedor));
                this.obtenerColorimetros(this.odt.proveedor.idLaboratorio);
                this.asignarNombreDetalleTrabajo();
                break;
              }
            }
          })
          this.listaCategorias.forEach((lc,i)=>{
            if(i != 3){
            lc.cardAbierto = false;
            }else{
              lc.cardAbierto = true;
            }
          });
        }
      }).finally(()=>{
        this.datosCargados = true;
      });
    },

  }
}
</script>

<style scoped>
.tituloCard.seleccionado{
  font-weight: 600;
  font-size: 12px !important;
  color: #60ADDC;
}

.tituloCard.completado {
  color: #28a745;
  font-weight: bold;
}
.tituloCard{
  font-size: 12px !important;
  color: #717171;
}
.cardOdtSel {
  border: 1px solid #7BBFE9;
  border-radius: 16px;
}
.cardOdtNoSel {
  border: 1px solid #b3b5b6;
  border-radius: 16px;
}

.cardOdtComplete {
  border: 1px solid #28a745;
  border-radius: 16px;
}
</style>
